import { schedulerInnerComponent } from "@/data/navigationComponents/navigationComponents";
import InnerComponent from "@/entities/InnerComponent";
import NavigationIcons from "@/entities/NavigationIcons";
import OptionalAccessSection from "@/entities/OptionalAccessSection";
import Roles from "@/entities/Roles";
import RouteNames from "@/entities/RouteNames";
import SideBarIcons from "@/entities/SidebarIcon";

export interface ISidebarNavDataChild {
  title: String;
  color?: String;
  slug: String | ISlugObject;
  icon?: String;
  styleClass?: String;
  parent?: boolean;
  optionalAccessSection?: OptionalAccessSection;
  innerComponent?: InnerComponent;
}

interface ISlugObject {
  name: RouteNames;
}

export interface ISidebarNavData {
  title: String;
  color?: String;
  role: Roles[];
  slug: String | ISlugObject;
  childColor?: String;
  borderColor?: any;
  activeColor?: any;
  styleClass?: string;
  defaultClass?: String;
  icon?: String;
  parent: boolean;
  children?: ISidebarNavDataChild[];
  optionalAccessSection?: OptionalAccessSection;
}
export const APP_COLORS = {
  DARK_YELLOW: "#f2b705",
  YELLOW: "#FFD43B",
  DARK_BLUE: "#0f55a8",
  BLUE: "#1a7bee",
  DARK_GREEN: "#1ca139",
  GREEN: "#0db952",
  DARK_PURPLE: "#471CA1",
  PURPLE: "#6E3BFF",
  DARK_GREY: "#bdbdbd",
  GREY: "#e0e0e0",
};
export const sidebarData: ISidebarNavData[] = [
  /**
   * Admin Side Bar
   */
  {
    title: "Company Resources",
    role: [Roles.ADMIN],
    color: "border-yellow",
    borderColor: "#f2b705",
    activeColor: "#FFD43B",
    childColor: "active-yellow",
    defaultClass: "yellow",
    slug: "/directory",
    icon: SideBarIcons.COMPANY_RESOURCES,
    parent: true,
    children: [
      {
        title: "Talent Directory",
        slug: { name: RouteNames.COMPANY_DATABASE },
        icon: SideBarIcons.TALENT_DIRECTORY,
      },
      //{
      //  title: "Talent Mapping",
      //  slug: { name: RouteNames.TALENT_MAPPING },
      //  icon: SideBarIcons.LOCATION,
      //},
      // {
      //   title: "Favorites",
      //   slug: { name: RouteNames.MY_FAVORITES },
      //   icon: SideBarIcons.FAVORITES,
      // },
      {
        title: "Managers",
        slug: { name: RouteNames.MANAGE_MANAGERS },
        icon: SideBarIcons.MANAGERS,
      },
      // {
      //   title: "Inbox",
      //   slug: { name: RouteNames.INBOX },
      //   icon: SideBarIcons.INBOX,
      // },
    ],
  },
  {
    title: "Manage Company",
    role: [Roles.ADMIN],
    slug: "/manage",
    color: "border-blue",
    borderColor: "#0f55a8",
    activeColor: "#1a7bee",
    childColor: "active-blue",
    defaultClass: "blue",
    icon: SideBarIcons.MANAGE_COMPANY,
    parent: true,
    children: [
      {
        title: "Clients",
        slug: { name: RouteNames.ALL_CLIENTS },
        icon: SideBarIcons.PROJECTS,
      },
      {
        title: "Visits",
        slug: { name: RouteNames.ALL_VISITS },
        icon: SideBarIcons.ALL_PROJECTS,
      },
      {
        title: "Scheduler", // Changed from Calendar to Scheduler
        slug: { name: RouteNames.CALENDAR },
        icon: SideBarIcons.CALENDAR,
      },
      {
        title: "Calendar", // Changed from Scheduler to Calendar
        slug: { name: RouteNames.NEW_MANAGE_SCHEDULE },
        icon: SideBarIcons.SCHEDULER,
      },
      // {
      // 	title: 'Talent Hunt',
      // 	slug: { name: RouteNames.TALENT_MAPPING },
      // 	icon: SideBarIcons.ALL_PROJECTS,
      // },
      {
        title: "Job Postings",
        slug: { name: RouteNames.RECRUITING_POSTINGS },
        icon: SideBarIcons.JOB_POSTINGS,
      },
      {
        title: "Groups",
        slug: { name: RouteNames.MANAGE_TEAMS },
        icon: SideBarIcons.GROUPS,
      },
      {
        title: "Timesheets",
        slug: { name: RouteNames.TIMESHEET },
        icon: SideBarIcons.TIME_SHEET,
        // innerComponent: schedulerInnerComponent,
      },

      {
        title: "Invoicing",
        slug: { name: RouteNames.INVOICE },
        icon: SideBarIcons.INVOICING,
      },
    ],
  },
  {
    title: "Documents",
    role: [Roles.ADMIN],
    slug: "/documents",
    color: "border-green",
    borderColor: "#1ca139",
    activeColor: "#0db952",

    childColor: "active-green",
    defaultClass: "green",
    icon: SideBarIcons.DOCUMENTS,
    parent: true,
    children: [
      {
        title: "All",
        slug: { name: RouteNames.DOCUMENTS_ADMIN_ALL },
        icon: SideBarIcons.ALL,
      },
      {
        title: "Clients",
        slug: { name: RouteNames.DOCUMENTS_ADMIN_PROJECTS },
        icon: SideBarIcons.PROJECTS,
      },
      {
        title: "Resources",
        slug: { name: RouteNames.DOCUMENTS_ADMIN_CONTRACTORS },
        icon: SideBarIcons.RESOURCES,
      },
      {
        title: "Managers",
        slug: { name: RouteNames.DOCUMENTS_ADMIN_MANAGERS },
        icon: SideBarIcons.MANAGERS,
      },
    ],
  },
  // {
  //   title: "ProveraCare Marketplace",
  //   role: [Roles.ADMIN],
  //   slug: { name: RouteNames.MARKETPLACE_CONTRACTORS },
  //   parent: false,
  //   styleClass: "marketPlace",
  //   icon: SideBarIcons.MARKETPLACE,
  //   optionalAccessSection: OptionalAccessSection.MARKETPLACE,
  // },
  {
    title: "Inbox",
    role: [Roles.ADMIN],
    styleClass: "inbox",
    slug: { name: RouteNames.INBOX },
    icon: SideBarIcons.INBOX,
    parent: false,
  },

  /***
   * Manage SiderBar
   *
   * **/

  {
    title: "Company Resources",
    role: [Roles.MANAGER],
    slug: "/directory",
    color: "border-yellow",
    childColor: "active-yellow",
    borderColor: "#f2b705",
    activeColor: "#FFD43B",

    defaultClass: "yellow",
    icon: SideBarIcons.COMPANY_RESOURCES,
    parent: true,
    children: [
      {
        title: "Talent Directory",
        slug: { name: RouteNames.COMPANY_DATABASE },
        icon: SideBarIcons.TALENT_DIRECTORY,
      },
      {
        title: "My Talent Directory",
        slug: { name: RouteNames.MANAGER_CONTRACTOR_DATABASE },
        icon: SideBarIcons.MY_TALENT_DIRECTORY,
      },
      // {
      //   title: "Talent Mapping",
      //   slug: { name: RouteNames.TALENT_MAPPING },
      //   icon: SideBarIcons.LOCATION,
      // },
      {
        title: "Managers",
        slug: { name: RouteNames.MANAGE_MANAGERS },
        icon: SideBarIcons.MANAGERS,
      },
      // {
      //   title: "Inbox",
      //   slug: { name: RouteNames.INBOX },
      //   icon: SideBarIcons.INBOX,
      // },
    ],
  },
  {
    title: "Manage Company",
    role: [Roles.MANAGER],
    slug: "/manage",
    color: "border-blue",
    childColor: "active-blue",
    borderColor: "#0f55a8",
    activeColor: "#1a7bee",

    defaultClass: "blue",
    icon: SideBarIcons.MANAGE_COMPANY,
    parent: true,
    children: [
      {
        title: "Clients",
        slug: { name: RouteNames.ALL_CLIENTS },
        icon: SideBarIcons.RESOURCE_ICON,
      },
      {
        title: "Visits",
        slug: { name: RouteNames.ALL_VISITS },
        icon: SideBarIcons.ALL_PROJECTS,
      },
      {
        title: "Scheduler", // Changed from Calendar to Scheduler
        slug: { name: RouteNames.CALENDAR },
        icon: SideBarIcons.CALENDAR,
      },
      {
        title: "Calendar", // Changed from Scheduler to Calendar
        slug: { name: RouteNames.NEW_MANAGE_SCHEDULE },
        icon: SideBarIcons.SCHEDULER,
      },
      // {
      //   title: "Talent Hunt",
      //   slug: { name: RouteNames.TALENT_MAPPING },
      //   icon: SideBarIcons.ALL_PROJECTS,
      // },
      {
        title: "Job Postings",
        slug: { name: RouteNames.RECRUITING_POSTINGS },
        icon: SideBarIcons.JOB_POSTINGS,
      },
      {
        title: "Groups",
        slug: { name: RouteNames.MANAGE_TEAMS },
        icon: SideBarIcons.GROUPS,
      },
      {
        title: "Timesheets",
        slug: { name: RouteNames.TIMESHEET },
        icon: SideBarIcons.TIME_SHEET,
        innerComponent: schedulerInnerComponent,
      },
    ],
  },
  {
    title: "Documents",
    role: [Roles.MANAGER],
    slug: "/documents",
    color: "border-green",
    childColor: "active-green",
    borderColor: "#1ca139",
    activeColor: "#0db952",

    defaultClass: "green",
    icon: SideBarIcons.DOCUMENTS,
    parent: true,
    children: [
      {
        title: "All",
        slug: { name: RouteNames.DOCUMENTS_MANAGER_ALL },
        icon: SideBarIcons.ALL,
      },
      {
        title: "Clients",
        slug: { name: RouteNames.DOCUMENTS_MANAGER_PROJECTS },
        icon: SideBarIcons.PROJECTS,
      },
      {
        title: "Resources",
        slug: { name: RouteNames.DOCUMENTS_ADMIN_CONTRACTORS },
        icon: SideBarIcons.RESOURCES,
      },

      {
        title: "Managers",
        slug: { name: RouteNames.DOCUMENTS_ADMIN_MANAGERS },
        icon: SideBarIcons.MANAGERS,
      },
    ],
  },
  // {
  //   title: "ProveraCare Marketplace",
  //   role: [Roles.MANAGER],
  //   slug: { name: RouteNames.MARKETPLACE_CONTRACTORS },
  //   parent: false,
  //   styleClass: "marketPlace",
  //   icon: SideBarIcons.MARKETPLACE,
  //   optionalAccessSection: OptionalAccessSection.MARKETPLACE,
  // },
  {
    title: "Inbox",
    role: [Roles.MANAGER],
    slug: { name: RouteNames.INBOX },
    icon: SideBarIcons.INBOX,
    styleClass: "inbox",
    parent: false,
  },
  /**
   * RESROUCE SIDEBAR
   *
   * */

  {
    title: "Personal",
    role: [Roles.CONTRACTOR],
    slug: "/",
    color: "border-yellow",
    childColor: "active-yellow",
    borderColor: APP_COLORS.DARK_YELLOW,
    activeColor: APP_COLORS.YELLOW,

    defaultClass: "yellow",
    icon: SideBarIcons.PERSONAL,
    parent: true,
    children: [
      {
        title: "Timesheets",
        slug: { name: RouteNames.CONTRACTOR_TIMESHEETS },
        icon: SideBarIcons.TIME_SHEET,
        innerComponent: schedulerInnerComponent,
      },
      {
        title: "Invoicing",
        slug: { name: RouteNames.INVOICE },
        icon: SideBarIcons.INVOICING,
      },
    ],
  },
  {
    title: "Manage Clients",
    color: "border-blue",
    childColor: "active-blue",
    borderColor: APP_COLORS.DARK_BLUE,
    activeColor: APP_COLORS.BLUE,

    defaultClass: "blue",
    role: [Roles.CONTRACTOR],
    icon: SideBarIcons.MANAGE_PROJECTS,
    slug: "/empty",
    parent: true,
    children: [
      {
        title: "Clients",
        slug: { name: RouteNames.CLIENT_All },
        icon: SideBarIcons.RESOURCE_ICON,
      },
      {
        title: "Visits",
        icon: SideBarIcons.ALL_PROJECTS,
        slug: { name: RouteNames.CLIENT_VISITS },
      },
      {
        title: "Scheduler", // Changed from Calendar to Scheduler
        slug: { name: RouteNames.CONTRACTOR_CALENDAR },
        icon: SideBarIcons.CALENDAR,
      },
    ],
  },

  {
    title: "Documents",
    color: "border-green",
    childColor: "active-green",
    defaultClass: "green",
    borderColor: APP_COLORS.DARK_GREEN,
    activeColor: APP_COLORS.GREEN,

    role: [Roles.CONTRACTOR],
    slug: "/documents",
    icon: SideBarIcons.DOCUMENTS,
    parent: true,
    children: [
      {
        title: "All",
        slug: { name: RouteNames.RESOURCES_DOCUMENTS },
        icon: SideBarIcons.ALL,
      },
      {
        title: "Clients",
        slug: { name: RouteNames.RESOURCES_PROJECT_DOCUMENTS },
        icon: SideBarIcons.PROJECTS,
      },
    ],
  },
  {
    title: "Network",
    color: "border-purple",
    childColor: "active-purple",
    defaultClass: "purple",
    borderColor: APP_COLORS.DARK_PURPLE,
    activeColor: APP_COLORS.PURPLE,

    role: [Roles.CONTRACTOR],
    icon: NavigationIcons.NETWORK,
    parent: true,
    slug: "/network",
    children: [
      {
        title: "Connections",
        slug: { name: RouteNames.NETWORK_CONNECTIONS },
        icon: SideBarIcons.CONNECTIONS,
      },
      {
        title: "Companies",
        slug: { name: RouteNames.NETWORK_COMPANIES },
        icon: SideBarIcons.COMPANIES,
      },
    ],
  },
  {
    title: "Job Board",
    role: [Roles.CONTRACTOR],
    slug: "/jobboard",
    color: "border-grey",
    childColor: "active-grey",
    borderColor: APP_COLORS.DARK_GREY,
    activeColor: APP_COLORS.GREY,

    defaultClass: "grey",
    icon: SideBarIcons.JOB_BOARD,
    parent: true,
    children: [
      {
        title: "Postings",
        slug: {
          name: RouteNames.JOBBOARD_POSTINGS,
        },
        icon: SideBarIcons.POSTINGS,
      },
      {
        title: "Applications",
        slug: { name: RouteNames.JOBBOARD_APPLICATIONS },
        icon: SideBarIcons.APPLICATIONS,
      },
    ],
  },
  {
    title: "Inbox",
    role: [Roles.CONTRACTOR],
    slug: { name: RouteNames.INBOX },
    icon: SideBarIcons.INBOX,
    styleClass: "inbox",
    parent: false,
  },
  // {
  // 	title: 'Recruiting',
  // 	role: [Roles.ADMIN, Roles.MANAGER],
  // 	slug: '/recruiting',
  // 	icon: NavigationIcons.RECRUITING,
  // 	parent: true,
  // 	children: [
  // 		{
  // 			title: 'Job Postings',
  // 			slug: { name: RouteNames.RECRUITING_POSTINGS },
  // 			icon: NavigationIcons.JOB_POSTING,
  // 		},
  // 	],
  // },

  // {
  // 	title: 'Inbox',
  // 	slug: { name: RouteNames.INBOX },
  // 	icon: NavigationIcons.INBOX,
  // 	parent: false,
  // 	role: [Roles.ADMIN, Roles.MANAGER, Roles.CONTRACTOR],
  // },
  // {
  // 	title: 'Invoice',
  // 	role: [Roles.CONTRACTOR, Roles.ADMIN],
  // 	slug: { name: RouteNames.INVOICE },
  // 	icon: NavigationIcons.DASHBOARD,
  // 	parent: false,
  // },
  // {
  // 	title: 'Dashboard',
  // 	role: [Roles.ADMIN, Roles.MANAGER],
  // 	slug: '/dashboard',
  // 	icon: NavigationIcons.DASHBOARD,
  // 	parent: false,
  // },
];

export default sidebarData;
